import BaseService from "./BaseService";

class AuthService {
  static async login(data) {
    return await BaseService.callAPI("/sign-in", "POST", data);
  }

  static async forgotPassword(data) {
    return await BaseService.callAPI("/forgot-password", "POST", data);
  }

  static async resetPassword(data) {
    return await BaseService.callAPI("/reset-password", "POST", data);
  }

  static async logout(data) {
    return await BaseService.callAPI("/self/logout", "POST", data);
  }

  static async requestOtp(data) {
    return await BaseService.callAPI("/sign-in/otp", "POST", data);
  }

  static async resendOtp(data) {
    return await BaseService.callAPI("/resend/otp", "POST", data);
  }

  static async verifyOtp(data) {
    return await BaseService.callAPI("/verify/otp", "POST", data);
  }

  static async refreshToken(data) {
    return await BaseService.callAPI("/refresh-session", "POST", null, null, {
      Authorization: `Bearer ${data.refreshToken}`,
    });
  }
}

export default AuthService;
